// family based configuration
const familyAttributes = [
	{
		label: {
			de: 'Montagevariante',
			en: 'Mounting',
			fr: 'Mounting'
		},
		id: 'mounting',
		options: [
			{
				value: 'system',
				label: {
					de: 'System',
					en: 'System',
					fr: 'System',
				}
			},
			{
				value: 'pole',
				label: {
					de: 'Mast',
					en: 'Pole',
					fr: 'Sur mât',
				}
			},
			{
				value: 'poleTopLuminaires',
				label: {
					de: 'Mastaufsatz',
					en: 'Pole top',
					fr: 'tête de mât',
				}
			},
			{
				value: 'lateralLuminaires',
				label: {
					de: 'Ansatz',
					en: 'Lateral',
					fr: 'latéraux',
				}
			},
			{
				value: 'polePendantLuminaires',
				label: {
					de: 'Mastpendel',
					en: 'Pole pendant',
					fr: 'suspendus',
				}
			},
			{
				value: 'lightColumns',
				label: {
					de: 'Lichtstelen',
					en: 'Columns',
					fr: 'Colonnes',
				}
			},
			{
				value: 'catenaryLuminaires',
				label: {
					de: 'Seilpendel',
					en: 'Catenary',
					fr: 'caténaires',
				}
			},
			{
				value: 'bollards',
				label: {
					de: 'Poller',
					en: 'Bollards',
					fr: 'Bornes',
				}
			},
			{
				value: 'wallMounted',
				label: {
					de: 'Wand',
					en: 'Wall',
					fr: 'murale',
				}
			}
		]
	},
	{
		label: {
			de: 'Circulares Lichtprofil',
			en: 'Circular Light Profile',
			fr: 'Circular Light Profile'
		},
		id: 'lightProfile',
		options: [
			{
				value: 'BiologicalRed',
				label: {
					de: 'Biologisch Rot',
					en: 'Biological Red',
					fr: 'Biological Red',
				}
			},
			{
				value: 'BiologicalWhite',
				label: {
					de: 'Biologisch Weiß',
					en: 'Biological White',
					fr: 'Biological White',
				}
			},
			{
				value: 'AdjustingWhite',
				label: {
					de: 'Dynamische Intensität',
					en: 'Adjusting White',
					fr: 'Adjusting White',
				}
			},
			{
				value: 'DynamicAmbiance',
				label: {
					de: 'Dynamische Ambiente',
					en: 'Dynamic Ambiance',
					fr: 'Dynamic Ambiance',
				}
			},
			{
				value: 'DynamicPath',
				label: {
					de: 'Dynamisch Horizontal',
					en: 'Dynamic Path',
					fr: 'Dynamic Path',
				}
			}
		]
	},
	{
		label: {
			de: 'Merkmale',
			en: 'Features',
			fr: 'Caractéristiques'
		},
		id: 'facets',
		options: [
			{
				value: 'nightsky',
				label: {
					de: 'Night-Sky',
					en: 'Night-Sky',
					fr: 'Night-Sky'
				}
			},
			{
				value: 'solar',
				label: {
					de: 'Solar',
					en: 'Solar',
					fr: 'Solaire'
				}
			},
			{
				value: 'smartcity',
				label: {
					de: 'Smart City',
					en: 'Smart City',
					fr: 'Smart City',
				}
			},
			{
				value: 'zhaga',
				label: {
					de: 'Zhaga Schnittstelle',
					en: 'Zhaga Interface',
					fr: 'Zhaga Interface'
				}
			},
			{
				value: 'tritec',
				label: {
					de: 'Tritec kompatibel',
					en: 'Tritec compatible',
					fr: 'Compatible Tritec'
				}
			},
			{
				value: 'wood',
				label: {
					de: 'Holzmaste',
					en: 'Wood Mast',
					fr: 'Mât bois'
				}
			},
			{
				value: 'classic',
				label: {
					de: 'Klassik',
					en: 'Classic',
					fr: 'Classiques'
				}
			},
			{
				value: 'gobo',
				label: {
					de: 'Gobo',
					en: 'Gobo',
					fr: 'Gobo'
				}
			}
		]
	}
];

export default familyAttributes;
